<!-- ForgotPassword.vue -->
<template>
	<div class="container mt-5">
		<h2>Forgot Password</h2>
		<form @submit.prevent="submitEmail">
			<div class="mb-3">
				<label for="email" class="form-label">Email address</label>
				<input
					type="email"
					class="form-control"
					id="email"
					v-model="email"
					required />
			</div>
			<button type="submit" class="btn btn-primary">Submit</button>
		</form>
		<div v-if="message" class="mt-3 alert" :class="messageClass">
			{{ message }}
		</div>
	</div>
</template>

<script setup>
	import { ref } from "vue"

	const email = ref("")
	const message = ref("")
	const messageClass = ref("")

	const submitEmail = async () => {
		try {
			const response = await fetch("/api/forgot-password", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ email: email.value }),
			})
			const result = await response.json()
			if (response.ok) {
				message.value = "Password reset link has been sent to your email."
				messageClass.value = "alert-success"
			} else {
				message.value = result.error || "An error occurred. Please try again."
				messageClass.value = "alert-danger"
			}
		} catch (error) {
			message.value = "An error occurred. Please try again."
			messageClass.value = "alert-danger"
		}
	}
</script>
